import Configuration from '@/agilis/util/Configuration'
import { mapGetters } from 'vuex'

// Mixin providing configuration utils methods
export default {
  name: 'DataTableConfigurationMixin',

  props: {
    configuration: Object
  },

  data () {
    return {
      itemDTO: {}
    }
  },

  computed: {
    ...mapGetters({
      'applicationId': 'contextStore/applicationId',
      'workspaceId': 'contextStore/workspaceId',
      'trackerTypeId': 'contextStore/trackerTypeId',
      'trackerId': 'contextStore/trackerId',
      'parentTrackerId': 'contextStore/parentTrackerId'
    }),

    dataTableConfiguration () {
      switch (this.mode) {
        case undefined:
        case 'select': {
          // Using query?
          // 1- querySelectModeDataTable defined in tracker datatable
          // 2- queryDataTable defined in tracker datatable (shared between different mode)
          // 3- datatable defined in the query
          // 4- (edge case, should never happen): tracker datatable
          if (this.searchViaSqlQuery) {
            const queryId = this.configuration.querySelectMode
            const dataTableFE = this.configuration.querySelectModeDatatable || this.configuration.queryDatatable
            const { dataTable: dataTableBE } = Configuration.getApplications()[this.applicationId]?.query[queryId]

            const dataTableQuery = dataTableFE || dataTableBE
            if (dataTableQuery) {
              return Configuration.datatable.mergeQueryDataTable(this.configuration, dataTableQuery)
            }
          }
          break
        }

        case 'edit':
        case 'insert': {
          // Using query?
          // 1- queryEditModeDataTable defined in tracker datatable
          // 2- queryDataTable defined in tracker datatable (shared between different mode)
          // 3- datatable defined in the query
          // 4- (edge case, should never happen): tracker datatable
          if (this.configuration.queryEditMode) {
            const queryId = this.configuration.queryEditMode
            const dataTableFE = this.configuration.queryEditModeDatatable || this.configuration.queryDatatable
            const { dataTable: dataTableBE } = Configuration.getApplications()[this.applicationId]?.query[queryId]

            const dataTableQuery = dataTableFE || dataTableBE
            if (dataTableQuery) {
              return Configuration.datatable.mergeQueryDataTable(this.configuration, dataTableQuery)
            }
          }
          break
        }

        case 'view': {
          // Using query?
          // 1- queryViewModeDataTable defined in tracker datatable
          // 2- queryDataTable defined in tracker datatable (shared between different mode)
          // 3- datatable defined in the query
          // 4- (edge case, should never happen): tracker datatable
          if (this.configuration.queryViewMode) {
            const queryId = this.configuration.queryViewMode
            const dataTableFE = this.configuration.queryViewModeDatatable || this.configuration.queryDatatable
            const { dataTable: dataTableBE } = Configuration.getApplications()[this.applicationId]?.query[queryId]

            const dataTableQuery = dataTableFE || dataTableBE
            if (dataTableQuery) {
              return Configuration.datatable.mergeQueryDataTable(this.configuration, dataTableQuery)
            }
          }
          break
        }

        default: break
      }

      // Regular flow: return tracker configuration as is
      return this.configuration
    }
  },

  methods: {
    decorateItems (items, themeIsDark = false) {
      return Configuration.datatable.decorateItems(this.dataTableConfiguration, items, themeIsDark)
    },

    setContext (itemDTO) {
      itemDTO.applicationId = this.applicationId
      itemDTO.workspaceId = this.workspaceId
      itemDTO.trackerTypeId = this.trackerTypeId
      itemDTO.trackerId = this.trackerId
      itemDTO.parentId = this.parentTrackerId
      return itemDTO
    }
  }
}
